import { useMemo } from 'react'
import { useTokenUSDPriceWithAmount } from '~/hooks/useTokenPrice'
import { useSpotSwapPair, useSpotSwapAmount } from '~/state/dex/hooks'
import { formatUnits } from 'viem'
import { FixedPointNumber } from '~/utils/fixedPoint'
import { NotificationLevel } from '~/components/NotificationBar'

/**
 * use for send by relayer
 */
export const useCalcSettlementFeeRisk = (settlementFee = 0n) => {
  const [inputToken, outputToken] = useSpotSwapPair()
  const { inputAmount } = useSpotSwapAmount()

  const inputAmountValue = useTokenUSDPriceWithAmount(
    inputToken?.address,
    inputAmount,
    false,
  ) as FixedPointNumber

  const feeValue = useTokenUSDPriceWithAmount(
    outputToken?.address,
    formatUnits(settlementFee, outputToken?.decimals),
    false,
    2,
    outputToken?.chainId,
  ) as FixedPointNumber

  const { level, percentage } = useMemo(() => {
    let level: NotificationLevel = 'info'
    const percentage = feeValue.div(inputAmountValue).times(100).toNumber()

    if (percentage >= 50) {
      level = 'risk'
    } else if (percentage >= 20) {
      level = 'warning'
    }

    return { level, percentage }
  }, [inputAmountValue, feeValue])

  return { level, percentage }
}
